export default __webpack_public_path__ + "4299f95d1eb5cc20fcc5525509ffd338.svg";